<template>
  <div id="news">
    <div class="container">
      <section class="introduction">
        <div class="columns">
          <div class="column is-4-tablet categories">
            <h2 class="title">{{ introduction.title }}</h2>
            <figure class="image is-3by1"></figure>
            <ul>
              <li v-for="(type, index) in introduction.list" :key="`types-${index}`">
                <span>{{ type.name }}</span>
                <figure v-if="type.image" class="image is-64x64 is-inline-block has-text-right">
                  <img :src="type.image" alt="">
                </figure>
              </li>
            </ul>
          </div>
          <div class="column technotrans is-8" v-if="articles">
            <div class="wrap">
              <figure class="image"><img :src="getImage(articles[0].document.bannerImage)"></figure>
              <div class="columns caption">
                <div class="column is-2 has-text-centered">
                  <figure class="image is-64x64 is-m-auto" v-if="articles[0].document.category === 'event'"><img src="@/assets/icons/events.svg"></figure>
                  <figure class="image is-64x64 is-m-auto" v-else-if="articles[0].document.category === 'press'"><img src="@/assets/icons/press.svg"></figure>
                  <figure class="image is-64x64 is-m-auto" v-else><img src="@/assets/icons/articles.svg"></figure>
                  <small>{{ articles[0].document.articleDate }}</small>
                </div>
                <div class="column is-8">
                  <h3 class="title">{{ articles[0].document.title }}</h3>
                  <p>{{ articles[0].document.summary }}</p>
                  <router-link class="is-flex" :to="{ name: 'article', params: { slug: articles[0].contentId }}">
                    Lire la suite <b-icon icon="chevron-right"></b-icon>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="tiles" v-if="articles">
        <div class="container columns is-multiline is-m-auto">
          <div class="column is-4 is-flex" v-if="index > 0"
          v-for="(tile, index) in articles" :key="`tile-${index}`">
            <div class="box">
              <figure class="image is-64x64 is-m-auto" v-if="tile.document.category === 'event'"><img src="@/assets/icons/events.svg"></figure>
              <figure class="image is-64x64 is-m-auto" v-else-if="tile.document.category === 'press'"><img src="@/assets/icons/press.svg"></figure>
              <figure class="image is-64x64 is-m-auto" v-else><img src="@/assets/icons/articles.svg"></figure>
              <small class="has-text-centered">{{ tile.document.articleDate }}</small>
              <h3 class="title">{{ tile.document.title }}</h3>
              <p>{{ tile.document.summary }}</p>
              <router-link class="is-flex" :to="{ name: 'article', params: { slug: tile.contentId }}">
                Lire la suite <b-icon icon="chevron-right"></b-icon>
              </router-link>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import api from '@/services/api';
import * as icons from '@/assets/icons';

export default {
  name: 'news',
  data() {
    return {
      articles: null,
      introduction: {
        title: 'nos actualités',
        list: [
          // { name: 'tout' },
          { name: 'articles', image: icons.articles },
          { name: 'salons', image: icons.events },
          { name: 'presse', image: icons.press },
        ],
      },
    };
  },
  async created() {
    await this.fetchData();
  },
  watch: {
    $route: 'fetchData',
  },
  methods: {
    async fetchData() {
      const articles = await api.getArticles();
      this.articles = articles.sort((a, b) => new Date(b.metadata.createdAt) - new Date(a.metadata.createdAt));
    },
    getImage(source) {
      return api.getImage(source);
    },
  },
};
</script>

<style lang='sass'>
  #news
    .introduction
      margin-bottom: 6rem !important
      .columns
        position: relative
        ul
          margin: 6rem 0 0 0
          li
            position: relative
            display: flex
            margin: 1rem 0
            padding: 0 0 1rem 0
            align-items: center
            font-weight: 600
            text-transform: uppercase
            border-bottom: 3px solid #fe3904
            span
              flex: 1
              font-size: 1.1rem
      h2
        color: #fe3904
      figure
        display: flex
        flex-direction: column-reverse
        &.is-3by1
          padding: 0
          margin: 1rem 0 3rem 0
          height: 4px
          width: 10%
          background-color: #fe3904
      .categories
        position: relative
        &:first-child
          padding: 2rem 4rem 2rem 0
          height: 100%
          // background-color: #ecf1f4
        &::after
          position: absolute
          content: ""
          height: 100%
          width: 250%
          top: 0
          left: -50%
          background-color: #ecf1f4
          z-index: -1
      .technotrans
        display: flex
        .wrap
          margin-bottom: -10%
          width: 100%
          align-self: flex-end
    .tiles, .introduction
      .wrap
        position: relative
        .caption
          position: absolute
          margin-bottom: 0
          padding: 2rem 1rem 1.5rem
          width: 100%
          bottom: 0
          left: 0
          color: #ffffff
          background-color: #032f56
          p, small, a
            margin: 0.5rem 0 0 0
          small
            display: inline-block
          h3
            text-align: left
            color: #ffffff !important
          .column
            padding-top: 0
            padding-bottom: 0
          .column:first-child
            position: relative
            padding: 0
            &::after
              position: absolute
              content: ""
              height: 100%
              width: 4px
              top: 0
              right: -10px
              background-color: #fe3904
          .column:last-child
            padding-left: 2rem
            a
              display: flex
              align-items: center
              font-weight: 600
              color: #fe3904
      .box
        display: flex
        padding: 2rem 4rem
        width: 100% !important
        height: 100% !important
        flex-direction: column
        justify-content: space-between
        border-radius: 0
        box-shadow: none
        background-color: #ecf1f4
        .image
          margin-bottom: 1rem !important
        p
          color: #0e6faa
        a
          display: flex
          margin: 1rem 0 0 0
          align-items: center
          font-weight: 600
          color: #fe3904 !important
        h3
          position: relative
          margin: 1rem 0 2rem 0
          text-align: center
          text-transform: initial
          &::after
            position: absolute
            content: ""
            margin: 0 0 -1rem 0
            bottom: 0
            left: 45%
            height: 4px
            width: 10%
            border-bottom: 4px solid #fe3904

  @media screen and (max-width: 1023px)
    #news
      .introduction
        .technotrans
          margin: 0
</style>
